import { render, staticRenderFns } from "./QualidadeDoLeiteBP.vue?vue&type=template&id=d734fe72&scoped=true"
import script from "./QualidadeDoLeiteBP.vue?vue&type=script&lang=js"
export * from "./QualidadeDoLeiteBP.vue?vue&type=script&lang=js"
import style0 from "./QualidadeDoLeiteBP.vue?vue&type=style&index=0&id=d734fe72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d734fe72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
